import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Intercom from 'react-intercom'
import config from 'config'

import intercomDataSelector from 'redux/selectors/intercom/intercom_data_selector'

class IntercomIO extends PureComponent {

	render() {

		if (!this.props.shouldShowIntercom) {
			return null
		}

		return (
			<Intercom
				appID={config.intercom.appId}
				{...this.props.intercomData}
			/>
		)
	}
}

function mapStateToProps(state) {
	return intercomDataSelector(state)
}

IntercomIO.propTypes = {
	shouldShowIntercom: PropTypes.bool.isRequired,
	intercomData: PropTypes.shape({
		user_id: PropTypes.string.isRequired,
		email: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		created_at: PropTypes.string.isRequired,
	}).isRequired,
}

export default connect(mapStateToProps, null)(IntercomIO)
